<template>
	<div>
		<div class="current-values" v-for="(data, index) in data.user_pet" :key="data.id">
			<h3>Mascota {{index+1}}</h3>
			<div class="ctn-action-btns">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon small @click="data.editableFlag = !data.editableFlag" class="mr-2" v-bind="attrs" v-on="on">
							<span icon color="primary" small class="action-btn edit-pencil"></span>
						</v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon small @click="deleteData(data)" v-bind="attrs" v-on="on">
							<span icon color="primary" small class="action-btn remove-can"></span>
						</v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
			</div>
			<br/>
			<v-form
					:ref="'form'+index"
					v-model="data.valid"
					lazy-validation
			>
				<label for="">Nombres</label>
				<v-text-field
						:disabled="data.editableFlag"
						v-model="data.names"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Fecha y hora de nacimiento</label>
				<v-datetime-picker
						:disabled="data.editableFlag"
						v-model="data.birth_date"
						:rules="validationRules.required"
						dateFormat="yyyy-MM-dd"
						timeFormat="HH:mm:ss"
						width="340px"
						placeholder=""
						required
						:max="maxDate">
					<template slot="actions" slot-scope="{ parent }">
						<v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
					</template>
					<template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
					<template slot="timeIcon"><v-icon>mdi-timer</v-icon></template>
				</v-datetime-picker>
				<label for="">País de nacimiento</label>
				<v-autocomplete
						:disabled="data.editableFlag "
						v-model="data.born_country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						:rules="validationRules.required"
				></v-autocomplete>
				<label for="">Estado o departamento de nacimiento</label>
				<v-autocomplete
						v-model="data.born_place"
						:items="countries2[data.born_country]"
						menu-props="auto"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="data.editableFlag || !countries2[data.born_country]"
				></v-autocomplete>
				<v-btn v-if="!data.editableFlag" outlined color="primary" class="save-btn" @click="data.editableFlag = !data.editableFlag">
					Cancelar
				</v-btn>
				<v-btn color="primary" v-if="!data.editableFlag" class="save-btn ml-4" @click="updateDataAction(data, index)" :disabled="!data.valid || !data.birth_date">
					Guardar cambios
				</v-btn>
			</v-form>
		</div>
		<div class="new-child" v-if="newData.flag">
			<h3>Agregar mascota</h3>
			<v-form
					ref="newForm"
					v-model="newData.valid"
					lazy-validation
			>
				<label for="">Nombres</label>
				<v-text-field
						v-model="newData.names"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Fecha y hora de nacimiento</label>
				<v-datetime-picker
						v-model="newData.birth_date"
						:rules="validationRules.required"
						dateFormat="yyyy-MM-dd"
						timeFormat="HH:mm:ss"
						placeholder=""
						required>
					<template slot="actions" slot-scope="{ parent }">
						<v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
					</template>
					<template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
					<template slot="timeIcon"><v-icon>mdi-timer</v-icon></template>
				</v-datetime-picker>
				<label for="">País de nacimiento</label>
				<v-autocomplete
						v-model="newData.born_country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						required
						:rules="validationRules.required"
				></v-autocomplete>
				<label for="">Estado o departamento de nacimiento</label>
				<v-autocomplete
						v-model="newData.born_place"
						:items="states[0].states"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="!states[0].country"
				></v-autocomplete>
			</v-form>
			<v-btn color="primary" outlined class="save-btn" @click="newData.flag = false">
				Cancelar
			</v-btn>
			<v-btn color="primary" class="save-btn ml-4" @click="saveNewData" :disabled="!newData.valid || !newData.birth_date">
				Guardar cambios
			</v-btn>
		</div>
		<div class="ctn-btn" v-if="!newData.flag">
			<v-btn fab color="teal" dark small @click="newData.flag = true">
				<v-icon dark>mdi-plus</v-icon>
			</v-btn>
			<label @click="newData.flag = true">Agregar</label>
		</div>
		<v-dialog v-model="dialog" persistent max-width="350">
			<v-card>
				<v-card-title class="headline">Eliminar registro</v-card-title>
				<v-card-text>
					¿Realmente desea eliminar el registro?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="confirmDeleteData(currentData.id)">Borrar</v-btn>
					<v-btn color="gray" text @click="dialog = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {phones} from "../assets/js/phones.js"
  import {countries} from "../assets/js/countries.js"
  import {countries2} from "../assets/js/countries2.js"
  export default {
    name: "Pet.vue",
    data() {
      return {
        phones: phones,
        countries: countries,
        countries2: countries2,
        newData: {
          names: "",
          flag: false
        },
        showConfirm: false,
        dialog: false,
        currentData: {},
        validationRules: {
          required: [
            v => !!v || 'Debe ingresar un valor para este campo',
          ],
        },
        maxDate: new Date()
      }
    },
    computed: {
      ...mapState('pet',[
        'data']),
      states() {
        let country = countries.filter((item) => { return item.country == this.newData.born_country})
        if (!country.length) { country = [{}]}
        return country
      },
    },
    methods : {
      ...mapActions(
          'pet', [
            'fetchData',
            'removeData',
            'addData',
            'updateData',
          ]
      ),
      ...mapActions(['loaderChange']),
      saveNewData () {
        let valid = this.$refs.newForm.validate()
        if (valid) {
          this.loaderChange(true)
          this.addData(this.newData).finally(() => {
            this.loaderChange(false)
            this.newData.flag = false
            this.resetNewData()
          })
        }
      },
      resetNewData() {
        this.newData.names = ""
        this.newData.surnames = ""
        this.newData.birth_date = ""
        this.newData.born_country = ""
        this.newData.born_place = ""
      },
      deleteData(data) {
        this.currentData = data
        this.dialog = true
      },
      confirmDeleteData(data) {
        this.dialog = false
        this.loaderChange(true)
        this.removeData(data).finally(() => {
          this.loaderChange(false)
        })
      },
      updateDataAction (data, index) {
        let valid = this.$refs[`form${index}`][0].validate()
        if (valid) {
          this.loaderChange(true)
          this.updateData(data).finally(() => {
            this.loaderChange(false)
            data.editableFlag = true
          })
        }
      }
    },
    mounted() {
      this.fetchData()
    }
  }
</script>

<style lang="scss" scoped>
	$breakpoints: (
			'tablet': 768px,
	);
	@mixin mobile {
		@media screen and (max-width: map-get($breakpoints, tablet)) {
			@content;
		}
	}
	::v-deep .v-input {
		width: 250px;
		.v-messages__message {
			padding-top: 3px;
		}
		&.v-input--is-disabled {
			.v-input__slot::before {
				display: none;
			}
			.v-input__append-inner {
				display: none;
			}
			.v-text-field__details {
				display: none;
			}
		}
		.v-text-field__details {
			min-height: 0;
			.v-messages, .v-text-field__details {
				min-height: 0;
			}
		}
		.v-input__slot {
			margin-bottom: 0;
			.v-text-field__slot, .v-select__selections {
				input, .v-select__selection {
					color: #656565;
				}
			}
		}

	}
	::v-deep .v-date-picker-header__value button {
		text-transform: uppercase;
		font-size: 14px;
		margin-top: 2px;
	}
	.ctn-btn {
		font-weight: 200;
		margin-top: 20px;
		::v-deep .v-btn {
			background-color: #2C8886;
		}
		label {
			margin-left: 12px;
			vertical-align: middle;
			font-weight: 200;
		}
	}
	.save-btn {
		margin: 35px 0 20px;
		text-transform: none;
		font-size: 14px;
		width: 160px;
		border-radius: 7px;
		height: 40px;
		&.cancel {
			margin-left: 12px;
		}
		@include mobile {
			display: block;
			margin: 4px auto;
			&.cancel {
				margin-left: auto;
			}
		}
	}
	h3	{
		font-size: 16px;
		font-weight: 800;
		margin-bottom: 8px;
		margin-top: 12px;
		color: #656565;
	}
	.current-values {
		position: relative;
		display: inline-block;
		width: 100%;
		.ctn-action-btns {
			display: inline-block;
			position: absolute;
			top: 8px;
			right: 0;
		}
	}
	::v-deep .v-picker__body {
		width: 100% !important;
		.accent--text button, td .v-btn__content {
			color: #656565;
		}
	}
	.save-btn.ml-4 {
		@include mobile {
			margin-left: auto !important;
		}
	}
</style>
